import { Typography } from '@mui/material'
import React from 'react'

interface Props extends React.ComponentProps<typeof Typography>  {
  label: string,
  value: string | React.ReactNode
}

const Record = (props: Props) => {
  const { label, value, ...rest } = props;
  return (
    <Typography variant="body2" gutterBottom {...rest}>
      <strong>{label}: </strong>{value}
    </Typography>
  )
}

export default Record